import styled from 'styled-components';

const DateTimeContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

export default DateTimeContainer;
